import { ELSLoggingService } from '@els/els-ui-common-react';
import { RecContentItemTypeDto } from '../../apis/rec-gateway/rec-gateway.dtos';
import {
  CatalogAdaptiveLessonExternalEntityDto,
  CatalogOsmosisVideoExternalEntityDtoParsed,
  CatalogSherpathLessonExternalEntityDtoParsed,
  CatalogSimChartExternalEntityDtoParsed,
  CatalogSimChartSimulationEHRExternalEntityDtoParsed
} from '../../apis/sherpath-course-management-service/sherpath-course-management-service.dtos';
import { fileName } from '../../components/header-nav/navigation.utilities';
import { EntityProps } from '../model';

export const getAdaptiveLessonExternalEntity = (props: EntityProps) =>
  props.externalEntity as CatalogAdaptiveLessonExternalEntityDto;

export const getCommonExternalEntity = (props: EntityProps) => {
  const { externalEntity, contentItem } = props;
  let _parsedData;

  const _externalEntity = externalEntity as
    CatalogSherpathLessonExternalEntityDtoParsed |
    CatalogOsmosisVideoExternalEntityDtoParsed;

  try {
    _parsedData = JSON.parse(_externalEntity.entity.data);
  } catch (e) {
    _parsedData = {
      // Amazingly this fallback works because all these external entity types share a title property
      title: `${contentItem.type} - ${contentItem.id}`
    };
    ELSLoggingService.error(
      fileName,
      `Unable to parse external entity ${contentItem.id}`,
    );
  }

  return {
    ..._externalEntity,
    _parsedData
  };
};

export const getSimchartExternalEntity = (props: EntityProps) => {
  const { externalEntity, contentItem } = props;
  let _parsedData;
  const _externalEntity = externalEntity as CatalogSimChartExternalEntityDtoParsed | CatalogSimChartSimulationEHRExternalEntityDtoParsed;

  try {
    _parsedData = JSON.parse(_externalEntity.entity);
  } catch (e) {
    _parsedData = {
      // Amazingly this fallback works because all these external entity types share a title property
      title: `${contentItem.type} - ${contentItem.id}`
    };
    ELSLoggingService.error(
      fileName,
      `Unable to parse external entity ${contentItem.id}`,
    );
  }

  return {
    ..._externalEntity,
    _parsedData
  };
};

const customExternalEntityHandlers = {
  [RecContentItemTypeDto.ADAPTIVE_LESSON]: getAdaptiveLessonExternalEntity,
  [RecContentItemTypeDto.OSMOSIS_VIDEO]: getCommonExternalEntity,
  [RecContentItemTypeDto.TOPIC_OVERVIEW]: getCommonExternalEntity,
  [RecContentItemTypeDto.SHERPATH_LESSON]: getCommonExternalEntity,
  [RecContentItemTypeDto.SIM_CHART]: getSimchartExternalEntity,
  [RecContentItemTypeDto.SLS_SIMCHART_SIMULATION_EHR]: getSimchartExternalEntity,
} as const;

export const getCustomExternalEntityHandler = (contentType: RecContentItemTypeDto) =>
  customExternalEntityHandlers[contentType];
